import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$root/types/components/partials/modules.d.ts').TwoColumnBlock}
 */
const TwoColumn = ({
    heading1,
    textCol1,
    heading2,
    textCol2,
}) => {
    return (
        <div className='gap-y-16 grid'>
            <div className='w-full flex'>
                <div className='px-layout-col w-1/2 sm:w-1/3'>
                    <p>{heading1}</p>
                </div>
                <div className='px-layout-col w-1/2 sm:w-1/3'>
                    <p>{heading2}</p>
                </div>
            </div>
            <div className='w-full flex'>
                {textCol1 && (
                    <div
                        className='px-layout-col w-1/2 sm:w-1/3 column-block'
                        dangerouslySetInnerHTML={{__html: textCol1}}/>
                )}
                {textCol2 && (
                    <div
                        className='px-layout-col w-1/2 sm:w-1/3 column-block'
                        dangerouslySetInnerHTML={{__html: textCol2}}/>
                )}
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default TwoColumn;
